module.exports = __webpack_public_path__ + "static/media/flower-animation.53ebd1b6.gif";